import type { GameViewProps } from '../../types';
import * as React from 'react';
import { GameA as GameComponent } from '../../containers/GameA';

export function View(props: GameViewProps) {
  return (
    <>
      <GameComponent {...props} />
    </>
  );
}
